import { Injectable } from '@angular/core';

@Injectable()
export class PhoneService {

  phoneIsValid(phone: any): any {
    if (!phone) {
      return false;
    }

    const phoneWithoutSpace = phone.replace(/ /g, '');
    const regexp = new RegExp(/^\+?[0-9]{9,}(\,+[0-9]+\#?)?(\,+[0-9]+\#?)?$/, 'g');
    const containsLettersResult = regexp.test(phoneWithoutSpace);

    return containsLettersResult;
  }

  generateNumberForWhatsapp(phone): string {
    let phoneTransform: string;
    phoneTransform = phone.replace(/ /g, '');
    phoneTransform = phoneTransform.replace(/^[\D,]{1,}/g, '');
    phoneTransform = parseInt(phoneTransform, 10).toString();

    if (phoneTransform.length === 9) {
      phoneTransform = `34${phoneTransform}`;
    }
    if (phoneTransform.length > 11) {
      phoneTransform = phoneTransform.substring(0, 11);
    }

    if (phoneTransform.length < 9) {
      phoneTransform = '';
    }

    return phoneTransform;

  }

}
